import React, { useEffect, useState } from "react";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import MetricsBand from "@/components/MetricsBand";
import About from "@/components/About";
import Services from "@/components/Services";
import Industries from "@/components/Industries";
import WhyChooseUs from "@/components/WhyChooseUs";
import Approach from "@/components/Approach";
import AuditChecklist from "@/components/AuditChecklist";
import SapDigital from "@/components/SapDigital";
import Certifications from "@/components/Certifications";
import ClientsMarquee from "@/components/ClientsMarquee";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Landing() {
  const [, setLoaded] = useState(false);
  useEffect(() => {
    setLoaded(true);
  }, []);

  return (
    <div data-testid="landing-page" className="bg-white text-ink">
      <Nav />
      <main>
        <Hero />
        <MetricsBand />
        <About />
        <Services />
        <Industries />
        <WhyChooseUs />
        <Approach />
        <AuditChecklist />
        <SapDigital />
        <Certifications />
        <ClientsMarquee />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
